import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon-reseveMethod",
  "use": "icon-icon-reseveMethod-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-icon-reseveMethod\"><path clip-rule=\"evenodd\" d=\"M1 4.5C1 3.678 1.677 3 2.5 3h11c.822 0 1.5.678 1.5 1.5v7c0 .822-.678 1.5-1.5 1.5h-11c-.823 0-1.5-.678-1.5-1.5v-7zM13.5 4h-11c-.283 0-.5.218-.5.5v7c0 .283.217.5.5.5h11c.283 0 .5-.217.5-.5v-5H2.5v-1H14v-1c0-.282-.217-.5-.5-.5zM13 9H8v1h5V9z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol